module.exports = "/_next/static/images/no-result-found-42bc246aae1e3afe193776871e37e49c.png";